<app-page-headline
        [breadcrumbTitle]="'Tabelle Konfigurieren'"
        [breadcrumbs]="[
        { label: 'Tabellen', link: '/tabellen' },
        { label: 'Tabelle generieren', iconClass: 'fa fa-angle-double-right', link: '/tabellen/generieren' }
    ]"
        [mainTitle]="'Die effizienteste Lösung für individuelle Firmenrecherche'"
        [subtitle]="'Schluss mit veralteten, ungenauen oder teuren Adresslisten:\n'+
'                    Mit unserer Plattform erstellen Sie in Minuten eigene, punktgenaue Firmenlisten für Ihre Zielgruppe\n'+
'                    – immer aktuell, DSGVO-konform und genau auf Ihren Bedarf zugeschnitten.'"
        [titleImagePath]="'assets/images/saas1/title-logo.png'"
        [backgroundImage]="'assets/images/saas1/work-bg.png'">
</app-page-headline>
<app-card-banner-overview-section></app-card-banner-overview-section>
<app-call-to-action-section2></app-call-to-action-section2>
<app-pro-contra-prallax-section></app-pro-contra-prallax-section>
<app-user-markt-segment-section></app-user-markt-segment-section>
<app-attention-info-text-section></app-attention-info-text-section>
<app-call-to-action-section></app-call-to-action-section>

